/* eslint-disable no-undef */
import moment from "moment";
import api from "../../../services/service_pos";
// import Swal from 'sweetalert2'

export default {
  props: ["host"],
  data() {
    return {
      shiftDate: moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
      amount: 0,
      countDown: 0,
      initialTime: 0, // Initial time in seconds (e.g., 5 minutes)
      currentTime: 0, // Current time in seconds
      intervalId: null, // Variable to store the interval ID
      isRunning: false, // Flag to track whether the timer is running
      expense_amount: 0,
      currentTimeText: "",
      b1000: 0,
      b500: 0,
      b100: 0,
      b50: 0,
      b20: 0,
      b10: 0,
      b5: 0,
      b2: 0,
      b1: 0,
      description: this.host.my_description,
      branchName: "",
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      }
    };
  },
  computed: {
    formattedTime() {
      const zeroPad = (num, places) => String(num).padStart(places, "0");
      const minutes = Math.floor(this.currentTime / 60);
      const seconds = this.currentTime % 60;
      this.currentTimeText = `${zeroPad(minutes, 2)}:${
        seconds < 10 ? "0" : ""
      }${seconds}`;
      return `${zeroPad(minutes, 2)}:${seconds < 10 ? "0" : ""}${seconds}`;
    }
  },
  methods: {
    startTimer() {
      this.isRunning = true;
      // this.currentTime = 0
      // this.currentTime = 0
      this.intervalId = setInterval(() => {
        // if (this.currentTime > 0) {
        this.currentTime++;
        // } else {
        //   this.stopTimer()
        // }
      }, 1000);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    stopTimer() {
      clearInterval(this.intervalId);
      this.isRunning = false;
    },
    checkAmount() {
      if (this.amount === "") {
        this.amount = 0;
      }
    },
    checkValueBath() {
      if (this.b1000 === "") {
        this.b1000 = 0;
      } else if (this.b500 === "") {
        this.b500 = 0;
      } else if (this.b100 === "") {
        this.b100 = 0;
      } else if (this.b50 === "") {
        this.b50 = 0;
      } else if (this.b20 === "") {
        this.b20 = 0;
      } else if (this.b10 === "") {
        this.b10 = 0;
      } else if (this.b5 === "") {
        this.b5 = 0;
      } else if (this.b2 === "") {
        this.b2 = 0;
      } else if (this.b1 === "") {
        this.b1 = 0;
      }
    },
    amountValue() {
      if (this.b1000 === "") {
        this.b1000 = 0;
      } else if (this.b500 === "") {
        this.b500 = 0;
      } else if (this.b100 === "") {
        this.b100 = 0;
      } else if (this.b50 === "") {
        this.b50 = 0;
      } else if (this.b20 === "") {
        this.b20 = 0;
      } else if (this.b10 === "") {
        this.b10 = 0;
      } else if (this.b5 === "") {
        this.b5 = 0;
      } else if (this.b2 === "") {
        this.b2 = 0;
      } else if (this.b1 === "") {
        this.b1 = 0;
      }
      this.amount =
        parseFloat(this.b1000) * 1000 +
        parseFloat(this.b500) * 500 +
        parseFloat(this.b100) * 100 +
        parseFloat(this.b50) * 50 +
        parseFloat(this.b20) * 20 +
        parseFloat(this.b10) * 10 +
        parseFloat(this.b5) * 5 +
        parseFloat(this.b2) * 2 +
        parseFloat(this.b1);

      return this.amount;
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    checkExpenseAmount() {
      if (this.expense_amount === "") {
        this.expense_amount = 0;
      }
    },
    closeShift() {
      if (this.amountValue() > 0) {
        // console.log(this.amount)
        this.$store.commit("Loading");
        var obj = {
          b1000: parseFloat(this.b1000),
          b500: parseFloat(this.b500),
          b100: parseFloat(this.b100),
          b50: parseFloat(this.b50),
          b20: parseFloat(this.b20),
          b10: parseFloat(this.b10),
          b5: parseFloat(this.b5),
          b2: parseFloat(this.b2),
          b1: parseFloat(this.b1),
          current_time_text: this.currentTimeText,
          cash_amount: parseInt(this.amount),
          bank_amount: 0,
          change_amount: 0,
          credit_amount: 0,
          chq_amount: 0,
          promptpay_amount: 0,
          coupon_amount: 0,
          expense_amount: parseInt(this.expense_amount),
          my_description: this.description,
          host_code: this.host.host_code,
          id: this.host.id
        };
        api.closeShiftUpdate(
          this.REST_URL,
          obj,
          this.header,
          result => {
            if (result.response === "success") {
              this.$store.commit("clearOrderPayment");
              $("#ShiftModal").modal("hide");
              $("body").on("hidden.bs.modal", ".modal", function() {
                $(this).removeData("bs.modal");
              });
              this.openCashBox(this.host);
              this.printSendShift();
            } else {
              this.$notification["warning"]({
                message: "ปิดการขายไม่ได้",
                description: result.message
              });
            }
            this.$store.commit("Loading");
            $("body").on("hidden.bs.modal", ".modal", function() {
              $(this).removeData("bs.modal");
            });
          },
          error => {
            alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
            this.$store.commit("Loading");
          }
        );
      } else {
        this.alert_msg("warning", "ปิดกะการขาย", "ยอดปิดกะ ต้องมีค่ามากกว่า 0");
      }
    },
    printSendShift() {
      var obj = {
        host_code: this.host.host_code,
        doc_date: this.dateFormatDMY2(new Date()),
        shift_id: parseInt(this.host.id),
        printer_port: this.host.printer_port
      };
      this.$store.commit("Loading");
      api.PrintCloseShif(
        this.REST_URL,
        obj,
        this.header,
        result => {
          if (result.response === "success") {
            this.alert_msg(
              "success",
              "พิมพ์ใบปิดกะการขาย",
              "พิมพ์ใบปิดกะการขายประจำ " + this.host.host_name + " เรียบร้อย"
            );
            $("body").on("hidden.bs.modal", ".modal", function() {
              console.clear();
              $(this).removeData("bs.modal");
            });

            this.$router.push("/");
          } else {
            this.alert_msg("warning", "พิมพ์ใบปิดกะการขาย", result.message);
            $("body").on("hidden.bs.modal", ".modal", function() {
              console.clear();
              $(this).removeData("bs.modal");
            });
            // this.$store.commit("Loading");
            this.openCashBox(this.host);
            this.printSendShift();
            this.$router.push("/");
          }
          this.$store.commit("Loading");
        },
        error => {
          // this.openCashBox(this.host)
          // this.printSendShift()
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
          this.$store.commit("Loading");
          $("body").on("hidden.bs.modal", ".modal", function() {
            console.clear();
            $(this).removeData("bs.modal");
          });
        }
      );
    }
  },
  created() {
    const config = JSON.parse(localStorage.getItem("config"));
    this.branchName = config[0].branch_name.replaceAll(" ", "");
    // this.currentTime = 0
    // console.log(currentTime)
    this.startTimer();
  },
  mounted() {
    $("#ShiftModal").on(
      "show.bs.modal",
      function() {
        // eslint-disable-next-line no-extra-bind
        this.shiftDate = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
        this.currentTime = 0;
      }.bind(this)
    );
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/pos/shiftclosemodal.js